<template>
    <div class="modal-content m-selectionProducts">
        <!-- Modal Header -->
        <div class="modal-header bg-1">
            <modal-close />
            <div class="modal-title my-1">
                <h2 class="h3 mb-0">
                    Usunięto produkty z promocji
                    <span>
                        ({{ dictProducts.length }})
                    </span>
                </h2>
            </div>
        </div>

        <!-- Modal Body -->
        <div class="modal-body pt-0 pb-4 px-3">
            <div
                class="flex-grow-1 text-sm a-infoBar a-infoBar--warning my-3"
            >
                Wymienione produkty zostały usunięte z listy ze względu na zmianę ich jednostki (kg/szt).
                Z tego powodu nie mogą zostać aktywowane w wybranym mechanizmie promocyjnym.
            </div>

            <div class="m-selectionProducts__productList">
                <div class="c-table table-selection-products">
                    <div class="c-thead p-0">
                        <div class="c-td is-1" v-text="'Nazwa produktu'" />
                        <div class="c-td is-2" v-text="'EAN'" />
                    </div>
                    <div class="c-tbody" style="position: relative">
                        <div
                            v-for="product in dictProducts"
                            class="c-tr px-0"
                            :key="product.id"
                            style="min-height: 3rem;"
                        >
                            <div class="c-td is-1" v-text="product.name" />
                            <div class="c-td is-2" v-text="product.ean" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal Footer -->
        <div class="modal-footer" style="position: sticky; bottom: 0;">
            <the-btn
                class="ml-auto"
                @click.native="$store.dispatch('toggleModal', false)"
            >
                Zamknij
            </the-btn>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        modalArgs() {
            return this.$store.getters.modalState.args
        },

        dictProducts() {
            return this.modalArgs.products.map(product => ({
                ...product.dict_product
            }))
        }
    },

    beforeDestroy() {
        this.$store.dispatch('setChangedProducts', [])
    }
}
</script>
